module.exports = __webpack_public_path__ + "static/media/4.5_preview.55039009.png";